import { FC } from 'react';
import { Box, Stack } from '@mui/material';
import useEntityDrawerSpacing from '../../../../../../../../../entity-drawer-layout/use-entity-drawer-spacing';

const Illustration: FC<{ size: number }> = ({ size = 100 }) => (
    <svg width={size} height={size * 1.01} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3555_30950)">
            <circle cx="50" cy="50" r="50" fill="#708B9E" fillOpacity="0.3" />
            <path
                d="M25.9004 62.1489V18.0709C25.9004 16.345 27.2995 14.9459 29.0254 14.9459H70.9753C72.7012 14.9459 74.1003 16.345 74.1003 18.0709V36.0555M67.075 85.0558H70.9753C72.7012 85.0558 74.1003 83.6567 74.1003 81.9308V73.1154M59.1634 69.6113H62.0718C63.7977 69.6113 65.1968 71.0104 65.1968 72.7363V85.0558H23.1797C19.7279 85.0558 16.9297 82.2576 16.9297 78.8058V72.7363C16.9297 71.0104 18.3288 69.6113 20.0547 69.6113H50.8537M66.7593 14.9238L76.9557 14.9238C80.4074 14.9238 83.2057 17.722 83.2057 21.1738V27.2433C83.2057 28.9692 81.8066 30.3683 80.0807 30.3683H78.8905"
                stroke="#0A3A5B"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <path
                d="M35.5742 35.9375H58.4198M35.5742 43.75H58.4198M35.5742 51.5625H58.4198M35.5742 59.375H48.0179"
                stroke="#0A3A5B"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
            <path
                d="M38.5165 21.0293V22.4882H37.7552V21.0293H38.5165ZM38.4232 29.0507V30.3671H37.6668V29.0507H38.4232ZM39.0618 27.4494C39.0618 27.2627 39.0258 27.1006 38.9537 26.9631C38.8849 26.8255 38.7687 26.7027 38.605 26.5947C38.4445 26.4866 38.2284 26.3834 37.9566 26.2852C37.5341 26.1313 37.1641 25.9626 36.8464 25.7793C36.5288 25.5926 36.2816 25.3617 36.1047 25.0867C35.9312 24.8116 35.8444 24.4645 35.8444 24.0453C35.8444 23.6425 35.9377 23.2938 36.1244 22.999C36.3143 22.701 36.5779 22.4718 36.9152 22.3113C37.2525 22.1476 37.6438 22.0657 38.0892 22.0657C38.4363 22.0657 38.7474 22.1181 39.0225 22.2229C39.3008 22.3244 39.5383 22.4734 39.7347 22.6699C39.9345 22.8664 40.0868 23.1087 40.1916 23.3969C40.2996 23.6818 40.3537 24.0076 40.3537 24.3744H39.0569C39.0569 24.1714 39.0339 23.9913 38.9881 23.8341C38.9423 23.6769 38.8768 23.5443 38.7916 23.4362C38.7065 23.3249 38.6033 23.2414 38.4822 23.1857C38.3643 23.13 38.23 23.1022 38.0794 23.1022C37.8632 23.1022 37.6848 23.1431 37.544 23.225C37.4064 23.3069 37.3049 23.4182 37.2394 23.559C37.1772 23.6998 37.1461 23.8619 37.1461 24.0453C37.1461 24.2221 37.1788 24.3777 37.2443 24.5119C37.3131 24.6429 37.4277 24.7625 37.5882 24.8705C37.7519 24.9786 37.9762 25.0883 38.2611 25.1996C38.6868 25.3568 39.0569 25.5304 39.3712 25.7203C39.6856 25.907 39.9296 26.1362 40.1031 26.408C40.2767 26.6798 40.3635 27.0237 40.3635 27.4395C40.3635 27.8653 40.2652 28.2255 40.0688 28.5202C39.8755 28.8149 39.6037 29.0392 39.2534 29.1931C38.903 29.3471 38.4953 29.424 38.0303 29.424C37.7323 29.424 37.4375 29.3847 37.1461 29.3061C36.8546 29.2275 36.5894 29.0998 36.3503 28.923C36.1145 28.7429 35.9262 28.5055 35.7854 28.2107C35.6446 27.9127 35.5742 27.5476 35.5742 27.1153H36.8759C36.8759 27.3642 36.9087 27.5705 36.9742 27.7343C37.0397 27.898 37.1281 28.029 37.2394 28.1272C37.3507 28.2222 37.4752 28.2893 37.6127 28.3286C37.7503 28.3679 37.8894 28.3876 38.0303 28.3876C38.2595 28.3876 38.4494 28.3483 38.6 28.2697C38.754 28.1911 38.8686 28.0814 38.9439 27.9406C39.0225 27.7965 39.0618 27.6327 39.0618 27.4494Z"
                fill="#0A3A5B"
            />
            <path
                d="M87.3887 54.6582C87.3887 61.5618 81.7922 67.1582 74.8887 67.1582C67.9851 67.1582 62.3887 61.5618 62.3887 54.6582C62.3887 47.7546 67.9851 42.1582 74.8887 42.1582C81.7922 42.1582 87.3887 47.7546 87.3887 54.6582Z"
                fill="#F8F260"
                stroke="#0A3A5B"
                strokeWidth="2"
            />
            <path
                d="M73.3262 48.502C73.3262 47.639 74.0257 46.9395 74.8887 46.9395C75.7516 46.9395 76.4512 47.639 76.4512 48.502V55.8723C76.4512 56.7352 75.7516 57.4348 74.8887 57.4348C74.0257 57.4348 73.3262 56.7352 73.3262 55.8723V48.502Z"
                fill="#0A3A5B"
            />
            <path
                d="M76.4512 60.8146C76.4512 61.6775 75.7517 62.3771 74.8887 62.3771C74.0258 62.3771 73.3262 61.6775 73.3262 60.8146C73.3262 59.9517 74.0258 59.2521 74.8887 59.2521C75.7517 59.2521 76.4512 59.9517 76.4512 60.8146Z"
                fill="#0A3A5B"
            />
        </g>
        <defs>
            <clipPath id="clip0_3555_30950">
                <rect width="100" height="100" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

const NoPayments = () => {
    const { isMobile } = useEntityDrawerSpacing();
    return (
        <Stack
            sx={{
                p: 2,
                height: '100%',
                minHeight: '134px',
                maxHeight: '260px',
                backgroundColor: 'grey.50',
                border: '1px solid',
                borderColor: 'grey.200',
                borderRadius: '8px'
            }}
            spacing={3}
            alignItems="center"
            justifyContent="center"
        >
            <Illustration size={isMobile ? 60 : 100} />
            <Box
                sx={{
                    fontSize: isMobile ? '1.15rem' : '1.5rem',
                    lineHeight: 1.15,
                    fontWeight: 600,
                    color: 'primary.900'
                }}
            >
                No payments entered
            </Box>
        </Stack>
    );
};

export default NoPayments;
